import { useEffect, useState } from "react";
import axios from "axios";
import styles from "../assets/css/Questions.module.css";
import Header from "../components/Header";
import List from "../components/List";
import DeleteQuestion from "../deleteComponents/DeleteQuestion";
import AddQuestion from "../addComponents/addQuestion";
import EditQuestion from "../editComponents/editQuestion";
import { BASE_URL } from "../constants/constants";

const Questions = () => {
  const [state, setState] = useState([]);
  const [deleteQuestion, setDeleteQuestion] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editQuestionId, setEditQuestionId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 8;
  const token = localStorage.getItem("token");

  const headers = {
    Authorization:
      `Bearer ${token}`,
  };

  const getQuestions = (page = 1) => {
    const lang = "ru"; 
  
    const userQuestions = axios.get(
      `${BASE_URL}/v0/faq?type=1&page=${page}&limit=${itemsPerPage}&lang=${lang}`,
      { headers }
    );
    const driverQuestions = axios.get(
      `${BASE_URL}/v0/faq?type=2&page=${page}&limit=${itemsPerPage}&lang=${lang}`,
      { headers }
    );
  
    Promise.all([userQuestions, driverQuestions])
      .then(([userResponse, driverResponse]) => {
        const combinedData = [
          ...userResponse.data.result,
          ...driverResponse.data.result,
        ];
        setState(combinedData);
  
        const totalItems =
          userResponse.data.metadata.paginationCount +
          driverResponse.data.metadata.paginationCount;
        setTotalPages(Math.ceil(totalItems / itemsPerPage));
      })
      .catch((error) => {
        console.error("Ошибка при получении данных!", error);
      });
  };   

  const handleQuestionDelete = (id) => {
    axios.delete(`${BASE_URL}/v0/faq/` + id, { headers }).then(() => {
      getQuestions(currentPage);
      setDeleteQuestion(null);
    });
  };

  const openAddModal = () => {
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
  };

  const openEditModal = (id) => {
    setEditQuestionId(id);
  };

  const closeEditModal = () => {
    setEditQuestionId(null);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    getQuestions(currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (!showAddModal && !editQuestionId) {
      getQuestions(currentPage);
    }
  }, [showAddModal, editQuestionId]);

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.block}>
            <div className={styles.text}>FAQ</div>
            <button onClick={openAddModal} className={styles.createbutton}>
              <div className={styles.text1}>Создать</div>
              <img
                className={styles.createicon}
                src="/images/add.svg"
                alt="add icon"
              />
            </button>
            {showAddModal && <AddQuestion onClose={closeAddModal} />}
          </div>
          <div className={styles.container2}>
            {state.map((el) => (
              <div key={el.id}>
                <div className={styles.block1}>
                  <div className={styles.question}>{el.question}</div>
                  <div className={styles.comment}>{el.answer}</div>
                  <div className={styles.box}>
                    <img
                      onClick={() => openEditModal(el.id)}
                      className={styles.icons}
                      src="/images/edit.svg"
                      alt="edit icon"
                    />
                    <img
                      onClick={() => setDeleteQuestion(el.id)}
                      className={styles.icons}
                      src="/images/delete.svg"
                      alt="delete icon"
                    />
                    {deleteQuestion === el.id && (
                      <DeleteQuestion
                        onClose={() => handleQuestionDelete(el.id)}
                        category={el}
                        onCloseModal={() => setDeleteQuestion(null)}
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.block2}>
            <div className={styles.paginate}>
              <div className={styles.box3}>
                <img
                  className={styles.paginationicons}
                  src="/images/left.svg"
                  alt="left icon"
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              </div>
              <div className={styles.page}>
                {currentPage} / {totalPages}
              </div>
              <div className={styles.box4}>
                <img
                  className={styles.paginationicons}
                  src="/images/right.svg"
                  alt="right icon"
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              </div>
            </div>
          </div>

          {editQuestionId && (
            <EditQuestion
              questionId={editQuestionId}
              onClose={closeEditModal}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Questions;
